export enum CaseStatus {
  Open = 1,
  AIAnalysing = 2,
  AIAnalysingComplete = 3,
  WaitingConsultation = 4,
  ReportSent = 5,
  QuestionAsk = 6,
  QuestionAnswer = 7,
  Closed = 8
}
